import React, { useState } from 'react';
import { formatCurrencyHasSymbol } from '../../../../../utils/commonFunctions';
import { Button, Badge } from 'react-bootstrap';
import { onBoardingBillingPlanByCountryCodeApi } from '../../../../../constants/ApiConfigs';
import ChoosePlanPopup from './ChoosePlanPopup';
import { callApiWithoutDispatch } from '../../../../../utils/apiUtils';
import { BILLING_PLAN_TYPE } from '../../../../../features/signup/constantStep';
import { I18n } from 'react-redux-i18n';

export const filterCurrentPlanWithOther = (plans, currentPlanId) => {
  const currentPlan = plans.find(plan => plan._id === currentPlanId);
  if(!currentPlan) {
    return plans;
  }
  return plans.filter(plan => plan.planIdentifier !== currentPlan?.planIdentifier || plan._id === currentPlanId);
}

const CurrentPlan = ({
  billingUsage = {},
  newBillingPlan = {},
  onChangeNewBillingPlan,
  onResetPreviewBillingPlan,
  auth = {},
  context = {},
  loadingActions,
  handleLoadBillingUsage,
  permissions,
}) => {
  const [billingPlanByCountryCode, setBillingPlanByCountryCode] =
    useState(null);
  const [showChoosePlanPopup, setShowChoosePlanPopup] = useState(false);

  const handleChangePlanClick = async () => {
    onResetPreviewBillingPlan();
    if (!billingPlanByCountryCode) {
      loadingActions?.showLoadingSpiner();
      try {
        const response = await callApiWithoutDispatch(
          onBoardingBillingPlanByCountryCodeApi,
          {
            method: 'GET',
            params: {
              countryCode: auth?.selectedFleet?.countryCode,
              fleetId: auth?.selectedFleet?.fleetId,
              currentPlanId: billingUsage?.planId,
            },
          }
        );
        if (response?.res?.data) {
          setBillingPlanByCountryCode(
            filterCurrentPlanWithOther(response?.res?.data, billingUsage?.planId)
          );
        } else {
          context.notification(
            'error',
            'Failed to get billing plan by country code'
          );
        }
      } catch (error) {
        context.notification(
          'error',
          'Failed to get billing plan by country code'
        );
      } finally {
        loadingActions?.hideLoadingSpiner();
      }
    }
    setShowChoosePlanPopup(true);
  };

  const checkDisableMonthlyBtn = () => {
    if (billingUsage.billingType === BILLING_PLAN_TYPE.annual) {
      return true;
    }
    return false;
  };

  const checkDisableAnnualBtn = () => {
    if (billingUsage.billingType === BILLING_PLAN_TYPE.annual) {
      return true;
    }
    return false;
  };

  const calculateSavePercentage = () => {
    const monthlyPrice =
      billingUsage?.pricingConfigs?.find((p) => p.type === 'monthly')?.fee || 0;
    const annualPrice =
      billingUsage?.pricingConfigs?.find((p) => p.type === 'annual')?.fee || 0;
    if (monthlyPrice === 0 || annualPrice === 0) {
      return 0;
    }
    return Math.round(
      ((monthlyPrice * 12 - annualPrice) / (monthlyPrice * 12)) * 100
    );
  };

  const handleChooseNewPlan = (plan, billingType) => {
    setShowChoosePlanPopup(false);
    onChangeNewBillingPlan({
      ...plan,
      planId: plan._id,
      name: plan.planName,
      billingType,
    });
  };

  return (
    <>
      {showChoosePlanPopup && (
        <ChoosePlanPopup
          currentBillingPlan={billingUsage}
          onSubmit={handleChooseNewPlan}
          onClose={() => {
            setShowChoosePlanPopup(false);
          }}
          pricingConfigs={billingPlanByCountryCode || []}
          billingUsage={billingUsage}
        />
      )}
      <div className="current-plan">
        <div>
          <span className="plan-name">
            {I18n.t('billingUsage.currentPlan')}
          </span>
          <span className="plan-value">{billingUsage.planName}</span>
          <div
            className="d-flex align-items-center justify-content-start"
            style={{ lineHeight: 1, margin: '5px 0' }}
          >
            <span style={{ fontWeight: 500, fontSize: 32, marginRight: 10 }}>
              {formatCurrencyHasSymbol(billingUsage.fee || 0, billingUsage.currencyISO)}
            </span>
            <div>
              <span
                className="font-weight-500"
                style={{
                  fontSize: 12,
                  fontWeight: 500,
                  display: 'block',
                  marginBottom: 5,
                }}
              >
                {billingUsage.currencyISO}
              </span>
              <span
                style={{ fontSize: 12, fontWeight: 500, display: 'block' }}
              >{`/${
                billingUsage.billingType === BILLING_PLAN_TYPE.annual
                  ? I18n.t('billingUsage.annual')
                  : I18n.t('billingUsage.monthly')
              }`}</span>
            </div>
          </div>
          {permissions.actions && !billingUsage.customPlan && (
            <Button
              className="btn-header text-add-header"
              style={{
                fontSize: 16,
                fontWeight: 400,
                color: '#04BE76',
                padding: 0,
                lineHeight: 1,
              }}
              onClick={handleChangePlanClick}
            >
              {I18n.t('billingUsage.changePlan')}
            </Button>
          )}
        </div>
        {(!billingUsage.customPlan ||
          (billingUsage.customPlan &&
            billingUsage?.billingType !== 'annual')) && (
          <div className="btn-group-billing">
            <Button
              className={`btn-header ${
                newBillingPlan?.billingType === 'monthly' ? 'activedBtn' : ''
              }`}
              onClick={onResetPreviewBillingPlan}
              disabled={checkDisableMonthlyBtn() || !permissions.actions}
            >
              {I18n.t('signup.billingMonthly')}
            </Button>
            <Button
              className={`btn-header ${
                newBillingPlan?.billingType === 'annual' ? 'activedBtn' : ''
              }`}
              onClick={() => {
                onChangeNewBillingPlan({
                  ...newBillingPlan,
                  billingType: 'annual',
                });
              }}
              disabled={checkDisableAnnualBtn()}
            >
              {I18n.t('signup.billingAnnual')}
            </Button>
            <Badge>
              {I18n.t('signup.savePercentage').format(
                calculateSavePercentage()
              )}
            </Badge>
          </div>
        )}
      </div>
    </>
  );
};

export default CurrentPlan;
